<template>
  <div v-if="!isLoaded" class="b-loading__wrap">
    <div class="b-loading">
      <img
        src="../../../assets/images/Artboard 1_800.jpg"
        alt="loading_image"
      >
    </div>
  </div>
</template>
<script>
  export default {
    computed: {
      isLoaded() {
        return this.$store.state.loading.isLoaded;
      },
      stepsToLoad() {
        return this.$store.state.loading.stepsToLoad;
      },
      stepsLoaded() {
        return this.$store.state.loading.stepsLoaded;
      }
    }
  };
</script>
